// extracted by css-extract-rspack-plugin
export default {"delivery":"Delivery-module__delivery___gH8D3","deliveryIcon":"Delivery-module__deliveryIcon___sbRGE"};